import { tryFetch, HttpMethod, type HttpResponse } from '@/services/http'
import type { AuthErrorCode } from '../types/auth.enums'

const BASE_URL = import.meta.env.VITE_USER_SESSION_API_URL

const exchangeCode = async (
  code: string,
  state: string,
  redirectUri: string,
): Promise<HttpResponse<null, AuthErrorCode>> =>
  await tryFetch<null, AuthErrorCode>(HttpMethod.Post, BASE_URL, 'auth/exchange-code', {
    body: { code, state, redirectUri },
  })

const exchangeSession = async (): Promise<HttpResponse<null, AuthErrorCode>> =>
  await tryFetch<null, AuthErrorCode>(HttpMethod.Post, BASE_URL, 'auth/exchange-session')

const tryLogout = async (): Promise<HttpResponse<null, AuthErrorCode>> =>
  await tryFetch<null, AuthErrorCode>(HttpMethod.Post, BASE_URL, 'auth/logout')

export const authApi = {
  exchangeCode,
  exchangeSession,
  tryLogout,
}
